import styled from '@emotion/styled';
import { Modal, pxToRem } from '@modernhealth/vital-components';
import React, { useState } from 'react';

import { useSubmitCancelledSessionReviewMutation } from '../documents/submitCancelledSessionReviewMutation.generated';
import { appClient } from 'src/config/apollo';
import { SessionSurveyModalQuestions } from './SessionSurveyModalQuestions';
import { SessionSurveyModalSuccess } from './SessionSurveyModalSuccess';

const ModalWrapper = styled.div({
    paddingTop: pxToRem(32),
    paddingBottom: pxToRem(32),
    paddingLeft: pxToRem(24),
    paddingRight: pxToRem(24),
});

export enum SessionSurveyModalTestId {
    CloseButton = 'SessionSurveyModalTestId.CloseButton',
    Title = 'SessionSurveyModalTestId.Title',
    Description = 'SessionSurveyModalTestId.Description',
    RemoveBenefit = 'SessionSurveyModalTestId.RemoveBenefit',
}

interface SessionSurveyModalProps {
    onClose: VoidFunction;
    visible: boolean;
    coachingVisitUuid: string;
}

export const SessionSurveyModal: React.FC<SessionSurveyModalProps> = ({
    onClose,
    visible,
    coachingVisitUuid,
}) => {
    const [otherText, setOtherText] = useState<string>('');
    const [selectedReasons, setSelectedReasons] = useState({});
    const [submitted, setSubmitted] = useState<boolean>(false);
    const [submitCancelledSessionReviewMutation] = useSubmitCancelledSessionReviewMutation({
        client: appClient,
    });
    const reasonsToSubmit = Object.keys(selectedReasons).filter(key => selectedReasons[key]);

    const handleSubmit = async () => {
        await submitCancelledSessionReviewMutation({
            variables: {
                cancelledSessionReview: {
                    coachingVisitUuid: coachingVisitUuid,
                    otherText: otherText,
                    reasons: reasonsToSubmit,
                },
            },
        });
        setSubmitted(true);
    };

    const onSkip = async () => {
        await submitCancelledSessionReviewMutation({
            variables: {
                cancelledSessionReview: {
                    coachingVisitUuid: coachingVisitUuid,
                    otherText: otherText,
                    reasons: ['SKIPPED'],
                },
            },
        });
        onClose();
    };

    return (
        <Modal onCloseButtonClick={onSkip} isVisible={visible} maxWidth={500} noPaddings>
            <ModalWrapper>
                {submitted ? (
                    <SessionSurveyModalSuccess onClose={onClose} />
                ) : (
                    <SessionSurveyModalQuestions
                        onSkip={onSkip}
                        handleSubmit={handleSubmit}
                        otherText={otherText}
                        setOtherText={setOtherText}
                        selectedReasons={selectedReasons}
                        setSelectedReasons={setSelectedReasons}
                    />
                )}
            </ModalWrapper>
        </Modal>
    );
};
